module.exports = __webpack_public_path__ + "img/team-benjamin-dezayas.3194dece.jpg";